import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, from, throwError, timer } from 'rxjs';
import { catchError, delayWhen, retry, switchMap, timeout } from 'rxjs/operators';
import { Auth } from '@angular/fire/auth';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private firebaseUser: any;
  private readonly TIMEOUT_VALUE = 10000; // 10 seconds

  constructor(private auth: Auth, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');

    if (token) {
      request = this.addToken(request, token);
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401) {
          return this.handle401Error(request, next);
        } else {
          return throwError(error);
        }
      }),
      // timeout(this.TIMEOUT_VALUE),
      // retry(1),
      // delayWhen((_, retryCount) => timer(retryCount * 1000)) 
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.firebaseUser = this.auth.currentUser;

    if (!this.firebaseUser) {
      this.router.navigate(['auth/login']);
      return throwError('No user logged in');
    }

    return from(this.firebaseUser.getIdToken(true)).pipe(
      switchMap((token: any) => {
        localStorage.setItem('token', token);
        const newRequest = this.addToken(request, token);
        return next.handle(newRequest);
      }),
      catchError((error) => {
        console.error('Error refreshing token', error);
        return throwError(error);
      }),
      retry(1),
      map((response) => response as HttpEvent<any>)
    );
  }
}
